// Use the same merchant-editable weekly rows as the visible hours section.
function prostHoursTime(value) {
  const text = value.trim().toLowerCase();
  if (text === 'midnight') return 0;
  if (text === 'noon') return 720;
  const match = /^(1[0-2]|[1-9])(?::([0-5]\d))?\s*(am|pm)$/.exec(text);
  return match ? (Number(match[1]) % 12 + (match[3] === 'pm' ? 12 : 0)) * 60 + Number(match[2] || 0) : null;
}
function prostHoursSchedule(rows) {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  if (!Array.isArray(rows) || rows.length !== 7) return null;
  const schedule = Array(7).fill(null);
  for (const row of rows) {
    const day = days.indexOf(row?.day), text = String(row?.hours || '').trim();
    if (day < 0 || schedule[day] !== null || !text) return null;
    const periods = [];
    if (!/^closed$/i.test(text)) {
      for (const part of text.split(/[,;/]/)) {
        const pair = part.split(/\s*[\u2013\u2014-]\s*/);
        if (pair.length !== 2) return null;
        const start = prostHoursTime(pair[0]), end = prostHoursTime(pair[1]);
        if (start === null || end === null || start === end) return null;
        periods.push([start, end <= start ? end + 1440 : end]);
      }
    }
    schedule[day] = periods.sort((a, b) => a[0] - b[0]);
  }
  return schedule;
}
function prostHoursStatus(rows, now = Date.now()) {
  const schedule = prostHoursSchedule(rows);
  if (!schedule) return { state: 'unknown', text: 'See hours' };
  const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Detroit', weekday: 'long', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(now);
  const part = type => parts.find(p => p.type === type).value;
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const day = days.indexOf(part('weekday')), minute = Number(part('hour')) * 60 + Number(part('minute'));
  const clock = total => {
    const t = total % 1440, h = Math.floor(t / 60), m = t % 60;
    return t === 0 ? 'midnight' : `${h % 12 || 12}${m ? ':' + String(m).padStart(2, '0') : ''} ${h >= 12 ? 'PM' : 'AM'}`;
  };
  for (const offset of [-1, 0]) {
    for (const [start, end] of schedule[(day + offset + 7) % 7]) {
      if (minute >= start + offset * 1440 && minute < end + offset * 1440) return { state: 'open', text: `Open until ${clock(end)}` };
    }
  }
  for (let offset = 0; offset <= 7; offset++) {
    for (const [start] of schedule[(day + offset) % 7]) {
      if (offset || start > minute) return { state: 'closed', text: `Closed. Open ${offset === 0 ? 'today' : offset === 1 ? 'tomorrow' : days[(day + offset) % 7]} at ${clock(start)}` };
    }
  }
  return { state: 'closed', text: 'Closed. See hours' };
}
if (typeof customElements !== 'undefined' && !customElements.get('prost-hours-status')) {
  const requests = new Map();
  customElements.define('prost-hours-status', class extends HTMLElement {
    connectedCallback() {
      this.update = async () => {
        const location = this.dataset.location;
        const read = root => {
          const section = Array.from(root.querySelectorAll('[data-prost-hours]')).find(el => el.dataset.location === location);
          const data = section?.querySelector('[data-prost-weekly-hours]');
          return data ? JSON.parse(data.textContent) : null;
        };
        try {
          let rows = read(document);
          if (!rows) {
            const url = new URL(this.dataset.hoursUrl, window.location.origin);
            if (url.origin !== window.location.origin) throw Error('Invalid hours source');
            if (!requests.has(url.href)) requests.set(url.href, fetch(url, { signal: AbortSignal.timeout(8000) }).then(r => {
              if (!r.ok) throw Error('Hours unavailable');
              return r.text();
            }).then(html => read(new DOMParser().parseFromString(html, 'text/html'))));
            rows = await requests.get(url.href);
          }
          if (!this.isConnected) return;
          const status = prostHoursStatus(rows);
          this.textContent = status.text;
          this.dataset.state = status.state;
        } catch (_) {
          if (this.isConnected) { this.textContent = 'See hours'; this.dataset.state = 'unknown'; }
        }
      };
      this.update();
      this.timer = setInterval(this.update, 60000);
      document.addEventListener('shopify:section:load', this.update);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('shopify:section:load', this.update);
    }
  });
}
